<div class="field" [formGroup]="form" [class.error]="emailError.hasError('*', 'touched')">
  <label for="email" translate>auth.login.email</label>
  <input type="email" formControlName="email" [placeholder]="'auth.login.email' | translate">
  <div class="box-error" ngxErrors="email" #emailError="ngxErrors">
    <p class="error" ngxError="required" when="touched" translate>error.required</p>
    <p class="error" ngxError="email" when="touched" translate>error.email</p>
  </div>
</div>



// WEBPACK FOOTER //
// /var/lib/jenkins/jobs/ubaristi-app-test/workspace/src/app/auth/login/login-form/login-email-field/login-email-field.component.html